export default __webpack_public_path__ + "static/media/2008-AMcover.b1d715f9.png";